import { centerable as g } from "../decorators/centerable.js";
import { uploadable as u } from "../decorators/uploadable.js";
import { ALIGN_CLASSES as c } from "../../constants.js";
import { defineAttrs as d } from "../../utils/typed-attrs.js";
import "../../bundled_deps/.pnpm/tinycolor2@1.6.0/bundled_deps/tinycolor2/esm/tinycolor.js";
const h = d({
  type: { default: "inlineImage" },
  src: { default: "" },
  linkUrl: { default: "" },
  width: { default: "" },
  displayWidth: { default: "" },
  height: { default: "" },
  text: { default: "" },
  className: { default: "" }
}), o = g(
  u({
    inline: !0,
    draggable: !0,
    attrs: h,
    group: "inline",
    parseDOM: [
      {
        tag: ".intercom-inline-image",
        priority: 60,
        getAttrs(t) {
          const e = t;
          return {
            src: e.getAttribute("src"),
            text: e.getAttribute("alt"),
            // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
            width: t.getAttribute("data-width") || t.style.width.replace("px", ""),
            className: t.getAttribute("data-class-name") ?? ""
          };
        }
      },
      {
        tag: "img[src]",
        getAttrs(t) {
          return {
            src: t.getAttribute("src"),
            linkUrl: t.getAttribute("data-link-url"),
            // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
            width: t.getAttribute("data-width") || t.style.width.replace("px", ""),
            height: t.getAttribute("data-height"),
            text: t.getAttribute("alt"),
            className: t.getAttribute("data-class-name") ?? ""
          };
        }
      }
    ],
    toDOM(t) {
      const e = t.attrs, { src: r, width: i, height: l, text: s, className: n } = e;
      let { displayWidth: a } = e;
      return a = a || i, [
        "img",
        {
          src: r,
          alt: s,
          class: `${c[e.alignment]} intercom-inline-image`,
          style: `width: ${a}px;`,
          "data-link-url": e.linkUrl,
          "data-height": l,
          "data-width": i,
          "data-class-name": n
        }
      ];
    }
  })
);
export {
  o as inlineImageSpec
};
